var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrelica = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.001 83.8594V69.7177H69.7179V118H83.8597L93.8593 128L103.859 118H118.001V103.859L128 93.859L118.001 83.8594ZM93.8593 108.233L79.4856 93.859L93.8593 79.4854L108.233 93.859L93.8593 108.233Z",
    fill: "#FFBB30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.53525 93.859L32.6766 69.7177H9.9996V83.8594L0 93.859L9.9996 103.859V118H24.1414L34.141 128L44.1406 118H58.2823V95.3234L34.141 119.465L8.53525 93.859ZM34.141 79.4826L19.7645 93.859L34.141 108.233L48.515 93.859L34.141 79.4826ZM35.6054 69.7177H43.0352H58.2824V92.3947L35.6054 69.7177Z",
    fill: "#8476CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118 9.9996V24.1414L128 34.1409L118 44.1405V58.2823H95.3234L119.465 34.1409L93.859 8.53524L69.7177 32.6766V9.9996H83.8594L93.859 0L103.859 9.9996H118ZM93.94 19.7657L79.5648 34.141L93.94 48.5162L108.315 34.141L93.94 19.7657ZM69.7177 58.2823H92.3947L69.7177 35.6053V58.2823Z",
    fill: "#D15962"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1406 9.9996L34.141 0L24.1414 9.9996H9.9996V24.1414L0 34.1409L9.9996 44.1405V58.2823H58.2823V9.9996H44.1406ZM34.141 48.5146L19.7673 34.1409L34.141 19.7673L48.5146 34.1409L34.141 48.5146Z",
    fill: "#21C4BC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrelica);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/trelica.7000a4fe8a2f23aca31e086e699bd730.svg";